import React, { useState, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const Login = () => {
  const { login, isAuthenticated } = useContext(AuthContext);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [isLoading, setIsLoading] = useState(false);

  const { email, password } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await login({ email, password });
    } finally {
      setIsLoading(false);
    }
  };

  if (isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <div className="flex min-h-[calc(100vh-8rem)] items-center justify-center">
      <div className="grid w-full max-w-5xl grid-cols-1 gap-8 rounded-3xl bg-white/90 p-10 shadow-2xl backdrop-blur lg:grid-cols-2">
        <div className="flex flex-col justify-center gap-6 rounded-2xl bg-gradient-to-br from-indigo-600 via-violet-600 to-purple-600 p-8 text-white shadow-lg">
          <div className="text-4xl" aria-hidden>📚</div>
          <div className="space-y-2">
            <h1 className="text-3xl font-semibold">Chào mừng trở lại</h1>
            <p className="text-sm text-indigo-100">Đăng nhập để tiếp tục hành trình học tập của bạn</p>
          </div>
          <div className="grid gap-3 text-sm text-indigo-100">
            <div className="flex items-center gap-3">
              <span className="text-xl">🎯</span>
              <span>Học tập hiệu quả với EduSmart</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xl">👥</span>
              <span>Kết nối cộng đồng học tập</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xl">🏆</span>
              <span>Theo dõi tiến độ và thành tích</span>
            </div>
          </div>
        </div>

        <div className="space-y-8">
          <form onSubmit={onSubmit} className="space-y-6">
            <div className="space-y-2">
              <label htmlFor="email" className="text-sm font-medium text-slate-600">
                📧 Địa chỉ email
              </label>
              <input
                type="email"
                id="email"
                placeholder="Nhập địa chỉ email của bạn"
                name="email"
                value={email}
                onChange={onChange}
                required
                className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-700 shadow-sm transition focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-100"
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="password" className="text-sm font-medium text-slate-600">
                🔒 Mật khẩu
              </label>
              <input
                type="password"
                id="password"
                placeholder="Nhập mật khẩu của bạn"
                name="password"
                value={password}
                onChange={onChange}
                required
                className="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-700 shadow-sm transition focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-100"
              />
            </div>

            <button
              type="submit"
              className={`inline-flex w-full items-center justify-center gap-3 rounded-xl bg-indigo-600 px-4 py-3 text-sm font-semibold text-white shadow-lg shadow-indigo-200 transition hover:bg-indigo-700 ${isLoading ? 'cursor-wait opacity-90' : ''}`}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="h-4 w-4 animate-spin rounded-full border-2 border-white/40 border-t-white"></span>
                  Đang đăng nhập...
                </>
              ) : (
                <>
                  🚀 Đăng nhập
                </>
              )}
            </button>
          </form>

          <div className="rounded-2xl bg-slate-50 p-6 text-center text-sm text-slate-600">
            <p>
              Cần tài khoản? Liên hệ với quản trị viên để được cấp tài khoản học tập.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
